import * as taskName from './task-name'
import {createValidationMessage} from '../../../../validation/create-validation-message'

import {createUIDefinition} from '../default-task-definition'
import {selectProcessContext} from '../../../state/instance-detail/selector'
import * as processUI from '../../process-ui'

export default createUIDefinition({
    taskName: taskName.PROVIDE_MOVEMENT_CERTIFICATE_NUMBER,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.MOVEMENT_CERTIFICATE_NUMBER_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
            readOnly: true,
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        if (eventName !== 'movement_certificate_number_provided') {
            return null
        }

        const messageList = []

        const movementCertificateNumber = context.movementCertificateNumber
        if (!movementCertificateNumber) {
            messageList.push(createValidationMessage('Please enter a movement certificate number.', 'empty-movement-certificate'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/provide-movement-certificate-number.js